import { render, staticRenderFns } from "./EditAuthor.vue?vue&type=template&id=2c8235b9&"
import script from "./EditAuthor.vue?vue&type=script&lang=js&"
export * from "./EditAuthor.vue?vue&type=script&lang=js&"
import style0 from "./EditAuthor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports